import {
  TRAIL_IOCS_SET,
  TRAIL_IOCS_REQ,
  TRAIL_IOCS_SUCCESS,
  TRAIL_IOCS_ERROR,
  TRAIL_IOCS_RESET_STATUS
} from './detections.type'

import ApiRest from '@/api/api-rest'
import IQCollection from '@/resources/collections/IQCollection'
import Detection from '@/resources/models/Detection'
import { OrderByEnum } from '@/constants/orderby.constants'
import { iocDetectionsMetaInfo } from '@/column-header/detections/ioc-detections-meta'

const state = {
  trailIocsReqStatus: '',
  trailIocsList: {}
}

const getters = {
  trailIocsReqStatus: state => state.trailIocsReqStatus,
  trailIocsList: state => state.trailIocsList
}

// Best Practice - updates state
const mutations = {
  [TRAIL_IOCS_SET]: (state, data) => {
    state.trailIocsList = data
  },
  [TRAIL_IOCS_REQ]: state => {
    state.trailIocsReqStatus = 'loading'
  },
  [TRAIL_IOCS_SUCCESS]: (state, data) => {
    state.trailIocsReqStatus = 'saved'
  },
  [TRAIL_IOCS_ERROR]: (state, errMsg) => {
    state.trailIocsReqStatus = 'error'
  },
  [TRAIL_IOCS_RESET_STATUS]: state => {
    state.trailIocsReqStatus = ''
  }
}

// Best Practice - actions call mutations
// make api call and commit states
const actions = {
  [TRAIL_IOCS_REQ] (context, { trailId, trailLabel, trailState } = {}) {
    let trailIdEncoded = encodeURIComponent(trailId)
    return new Promise((resolve, reject) => {
      context.commit(TRAIL_IOCS_REQ)
      ApiRest()
        .get(`/trails/ioc-detections/${trailIdEncoded}`)
        .then(({ data }) => {
          let isPrivilegedTrail = false
          if (trailLabel.includes('AP-')) {
            trailLabel = trailLabel.replace('AP-', '')
          } else {
            trailLabel = trailLabel.replace('PA-', '')
            isPrivilegedTrail = true
          }

          data = _.chain(data)
            .sort((a, b) => {
              return b.seenTime - a.seenTime // sort by desc
            })
            .map(detection => {
              let detectionRule = {}
              let detectionHost = {}

              if (detection.ruleid === 0) {
                detectionRule = {
                  id: 0,
                  name: detection.iocSummary
                }
              } else if (!_.isEmpty(context.rootState.rules.allRulesList)) {
                detectionRule = _.find(context.rootState.rules.allRulesList, {
                  id: `${detection.ruleid}`
                })
              }

              if (!_.isEmpty(context.rootState.agents.agentList.models)) {
                detectionHost = _.find(context.rootState.agents.agentList.models, {
                  agentId: detection.agentId
                })
              }
              if (_.isEmpty(detection.attackIdList)) {
                detection.attackIdList = [trailLabel]
              }
              if (_.isEmpty(detection.trailStateList)) {
                detection.trailStateList = [trailState]
              }
              if (_.isEmpty(detection.trailList)) {
                detection.trailList = [trailId]
              }
              detection.rule = detectionRule
              detection.host = detectionHost
              let ioc = new Detection(undefined, detection)
              ioc.privilege = isPrivilegedTrail
              ioc.setTrail(detection.attackIdList)
              return ioc
            })
            .value()

          let detections = new IQCollection(
            data,
            { attributes: iocDetectionsMetaInfo.meta.columns },
            { defaultSort: 'seenTime', sortOrder: OrderByEnum.DESC }
          )

          context.commit(TRAIL_IOCS_SET, detections)
          resolve(detections)
        })
        .catch(errMsg => {
          context.commit(TRAIL_IOCS_ERROR, errMsg)
          reject(errMsg)
        })
    })
  },
  [TRAIL_IOCS_SUCCESS] (context) {
    context.commit(TRAIL_IOCS_SUCCESS)
  },
  [TRAIL_IOCS_RESET_STATUS] (context) {
    context.commit(TRAIL_IOCS_RESET_STATUS)
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/detections/traildetections.module.js